import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import Layout from './components/Layout'
import Paperlayout from './components/Paperlayout'
import Common from './common/common'
import router from './router'
import less from 'less'
import axios from 'axios'
//axios.defaults.baseURL = "http://exam.com/"
axios.defaults.baseURL = "https://es.xichuanwh.com/"
axios.defaults.fileURL = "https://xcwh-1327518518.cos.ap-chengdu.myqcloud.com"
Vue.prototype.$http = axios
Vue.config.productionTip = false
Vue.prototype.$Common = Common
Vue.use(ElementUI); 
Vue.use(less)
Vue.component('Layout', Layout)
Vue.component('Paperlayout', Paperlayout)
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
